module.exports = __webpack_public_path__ + "static/media/logoBlanco.ab25becd.svg";